window.onload = function () {
    if ( window.jQuery ) {

        if ( jQuery("#popWarn").val() ) {

            jQuery("#pop").on('click', function (e) {

                Swal.fire({
                    title: 'Important!',
                    text: jQuery("#popWarn").val(),
                    icon: 'warning',
                    confirmButtonText: 'I Agree',
                    showCancelButton: true,
                    confirmButtonColor: '#009743',
                    cancelButtonColor: '#d33',
                }).then((result) => {
                    if ( result.isConfirmed ) {
                        jQuery("#popConfirm").click();
                    }
                })
            });
        }
    }
}
